module.exports = "https://web-assets.ifttt.com/packs/media/icons/drizzle-e1656929.png";